import {Model} from './model';
import {Unserializer} from './serialization';

export class SmsLog implements Model {
  smsLogId: number;
  invoiceId?: number;
  userId: number;
  success: boolean;
  recipient: string;
  message: string;
  response: string;
  created: Date;

  static copy(oldObj: SmsLog): SmsLog {
    const newObj = new SmsLog();
    newObj.smsLogId = oldObj.smsLogId;
    newObj.invoiceId = oldObj.invoiceId;
    newObj.userId = oldObj.userId;
    newObj.success = oldObj.success;
    newObj.recipient = oldObj.recipient;
    newObj.message = oldObj.message;
    newObj.response = oldObj.response;
    newObj.created = Unserializer.date(oldObj.created);
    return newObj;
  }

  public getPrimaryKey(): number {
    return this.smsLogId;
  }

  isNew(): boolean {
    return isNaN(this.smsLogId);
  }

  clone(): SmsLog {
    return SmsLog.copy(this);
  }
}
